import type SceneControl from '../scene/scene'

const useframe = (sceneControl: SceneControl, cb: (delta: number) => void) => {
  sceneControl.context.addFrameCallback(cb)
  return () => sceneControl.context.removeFrameCallback(cb)
}

export default useframe
